const APP_ORIGIN = 'https://agentplane.ejaaz.online';

function broadcastToFrames(host, message) {
    if (typeof host.document === 'undefined') return;
    host.document.querySelectorAll('iframe[title="Agent chat"], iframe[title="محادثة دعم Coding With Ghonaim"]').forEach((frame) => {
        try {
            frame.contentWindow.postMessage(message, APP_ORIGIN);
        } catch (e) { /* ignore cross-window errors */ }
    });
}

// Load no third-party code until the support widget is requested.
// When bubble + inline embeds both run, window.Agentplane only reaches the last
// script instance — so we also postMessage every Agent chat iframe.
export function createAgentplaneIdentity(host) {
    let active = false;
    let previousId;
    let previousIdentity;

    function sync(user) {
        if (!active) return;
        const id = user && user.id != null && String(user.id).trim() !== ''
            ? String(user.id) : null;
        if (id === null) {
            // Also clear a persisted widget session when first opened anonymously.
            if (previousId !== null) {
                host.Agentplane('reset');
                broadcastToFrames(host, { type: 'agentplane:reset' });
            }
            previousId = null;
            previousIdentity = undefined;
            return;
        }
        if (previousId != null && previousId !== id) {
            host.Agentplane('reset');
            broadcastToFrames(host, { type: 'agentplane:reset' });
        }
        const identity = {
            userId: id,
            email: user.email || undefined,
            phone: user.phone || undefined,
            name: user.name || undefined,
            attributes: { drasa_student_id: id, tenant: 'codingwithghonaim' },
        };
        const fingerprint = JSON.stringify(identity);
        if (fingerprint !== previousIdentity) {
            host.Agentplane('identify', identity);
            broadcastToFrames(host, { type: 'agentplane:identify', payload: identity });
        }
        previousId = id;
        previousIdentity = fingerprint;
    }

    return {
        activate(user) {
            host.Agentplane = host.Agentplane || function () {
                (host.Agentplane.q = host.Agentplane.q || []).push(arguments);
            };
            active = true;
            sync(user);
        },
        refresh(user) {
            previousIdentity = undefined;
            if (!user || user.id == null || String(user.id).trim() === '') previousId = undefined;
            sync(user);
        },
        sync,
    };
}
